import { SvgIcon } from '@material-ui/core'

export function ChevronDownIcon(props) {
  return (
    <SvgIcon {...props} fill="none">
      <path
        d="M6 9L12 15L18 9"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
